import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'
import { Tabs } from 'expo-router'

export default function TabLayout() {
  return (
    <Tabs screenOptions={{ tabBarActiveTintColor: '#e4007d' }}>
      <Tabs.Screen
        name="index"
        options={{
          title: 'Dashboard',
          tabBarIcon: (props) => <FontAwesomeIcon icon={['fal', 'home']} {...props} />,
        }}
      />
      <Tabs.Screen
        name="folders"
        options={{
          title: 'My folders',
          tabBarIcon: (props) => <FontAwesomeIcon icon={['fal', 'folders']} {...props} />,
          headerShown: false,
          lazy: false,
        }}
      />
      <Tabs.Screen
        name="settings"
        options={{
          title: 'Settings',
          tabBarIcon: (props) => <FontAwesomeIcon icon={['fal', 'wrench']} {...props} />,
        }}
      />
    </Tabs>
  )
}
